import { TOGGLE_NAV } from './actions';

const initialState = {
  isOpen: false
};

export default function navReducer(state = initialState, action) {
  switch (action.type) {
    case TOGGLE_NAV:
      return { ...state, isOpen: !state.isOpen };

    case '@@router/LOCATION_CHANGE':
      return { ...state, isOpen: false };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/nav/reducer.js